<div class="banner-info-container">
    <div class="container">
      <div class="pt-5">
        <h1 class="pb-3 heading">Easy Solar Financing</h1>
        <p class="pb-3">Explore seamless financing options through our partners and embrace a brighter, sustainable future with
          Luminous Solar Solutions.</p>
        <div class="row dataContainer mt-5 d-flex" *ngIf="bannerListData?.length">
          <div #carousel class="imageCarosuel position-relative">
            <owl-carousel-o [options]="customOptions">
              <ng-container *ngFor="let slideData of bannerListData">
                <ng-template carouselSlide>
                    <img loading="lazy" role="button" class="bannerImage" [src]="slideData.imageUrl" [alt]="slideData.bannerName">
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
          <div class="col-md-3 mb-5 d-flex justify-content-center align-items-center videoContainer">
            <iframe width="245" height="345" src="https://www.youtube.com/embed/twLEjwtKvx4?autoplay=1&rel=0&controls=0&mute=1" frameborder="0" allowfullscreen (load)="videoLoaded()"></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5 pt-5 pdfList" *ngIf="pdfListingData?.length">
      <div class="col-md-3 mt-2 mb-2 d-flex justify-content-center align-items-center" *ngFor="let pdfData of pdfListingData">
        <div class="pdf-box w-100 d-flex justify-content-center align-items-center"  (click)="viewPDF(pdfData.pdfUrl)">
          <a href="{{pdfData.pdfUrl}}"  target="_blank">
            <h4 class="text-center m-0">{{pdfData.pdfName}}</h4>
          </a>
        </div>
      </div>
    </div>
  </div>
  